import React from "react";
import PropTypes from 'prop-types';

class ReportOutput extends React.Component {
	render() {
		return null;
	}
}

ReportOutput.propTypes = {
	startDate: PropTypes.object,
	endDate: PropTypes.object
};

export default ReportOutput;